var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dialog-form-list',{attrs:{"config":_vm.config,"formData":_vm.formData,"title":_vm.title},on:{"cancel":_vm.cancel,"confirm":_vm.confirm}})
}
var staticRenderFns = []

export { render, staticRenderFns }